<template>
  <v-container class="py-8 admin-top">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title class="primary white--text text-center">
            <v-icon left>mdi-shield-lock</v-icon>
            Admin Login
          </v-card-title>

          <v-card-text class="pt-6">
            <v-form ref="form" v-model="valid" @submit.prevent="login">
              <v-text-field
                v-model="username"
                label="Username"
                :rules="[v => !!v || 'Username is required']"
                required
                outlined
                prepend-icon="mdi-account"
              ></v-text-field>

              <v-text-field
                v-model="password"
                label="Password"
                type="password"
                :rules="[v => !!v || 'Password is required']"
                required
                outlined
                prepend-icon="mdi-lock"
                @keyup.enter="login"
              ></v-text-field>

              <v-alert
                v-if="error"
                type="error"
                class="mt-4"
                prominent
              >
                {{ error }}
              </v-alert>
            </v-form>
          </v-card-text>

          <v-card-actions class="pa-6">
            <v-btn
              block
              color="primary"
              size="large"
              @click="login"
              :loading="loading"
              :disabled="!valid"
            >
              <v-icon left>mdi-login</v-icon>
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ADMIN_CONFIG } from '@/config/admin.js'
import config from '@/config.js'

export default {
  name: 'AdminLogin',
  data() {
    return {
      username: '',
      password: '',
      valid: false,
      loading: false,
      error: ''
    }
  },
  methods: {
    isAuthenticated() {
      const authenticated = localStorage.getItem('admin_authenticated')
      const timestamp = localStorage.getItem('admin_timestamp')
      const sessionDuration = localStorage.getItem('admin_session_duration') || ADMIN_CONFIG.sessionDuration
      
      if (!authenticated || !timestamp) return false
      
      // Check if session is still valid
      const sessionAge = Date.now() - parseInt(timestamp)
      const maxAge = parseInt(sessionDuration)
      
      if (sessionAge > maxAge) {
        localStorage.removeItem('admin_authenticated')
        localStorage.removeItem('admin_timestamp')
        localStorage.removeItem('admin_session_duration')
        return false
      }
      
      return true
    },
    async login() {
      if (!this.$refs.form.validate()) return

      this.loading = true
      this.error = ''

      try {
        // Call backend API for authentication using config
        const response = await fetch(`${config.API_BASE_URL}/admin/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            username: this.username,
            password: this.password
          })
        });

        const data = await response.json();

        if (data.success) {
          // Store JWT token and admin info
          localStorage.setItem('admin_token', data.token);
          localStorage.setItem('admin_authenticated', 'true');
          localStorage.setItem('admin_timestamp', Date.now().toString());
          localStorage.setItem('admin_session_duration', data.admin.sessionDuration.toString());
          localStorage.setItem('admin_info', JSON.stringify(data.admin));
          
          // Redirect to backoffice
          this.$router.push('/backoffice');
        } else {
          this.error = data.message || 'Login failed';
        }
      } catch (error) {
        console.error('Login error:', error);
        this.error = 'Network error. Please try again.';
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    // Redirect if already authenticated
    if (this.isAuthenticated()) {
      this.$router.push('/backoffice')
    }
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 12px;
}

.admin-top {
  margin-top: 150px;
}
</style> 